/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * AXIA CONFIDENTIAL                                                             *
 * ------------------                                                            *
 *                                                                               *
 * This file, project or its parts can not be copied and/or distributed without  *
 * the express permission of Axia Digital Solutions LTDA.                        *
 *                                                                               *
 * Project: kairos                                                               *
 * @file: footer.component.ts                                                    *
 * @Date: Thursday, 10th June 2021                                               *
 * @author: Nayara Goulart (nayara.goulart@axiadigitalsolutions.com)             *
 * ----                                                                          *
 * Last Modified: Thursday, 10th June 2021                                       *
 * Modified By: Nayara Goulart (nayara.goulart@axiadigitalsolutions.com)         *
 * ----                                                                          *
 * Copyright (C) 2020 Axia Digital Solutions LTDA - All Rights Reserved.         *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

import { Component, OnInit, HostListener } from '@angular/core';
import { EContactChannels, IContactDetails } from '../../models/IContactDetails';
import { IExternalLinks } from '../../models/IExternalLinks';
import { ConfigReaderService } from '../../services/util/config.reader.service';
import { UtilService } from '../../services/util/util.service';
import { forkJoin } from 'rxjs';
import { SimpleContactModalComponent } from '../../simple-contact-modal/simple-contact-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

    private externalLinks: IExternalLinks = undefined;
    private contactDetails: IContactDetails = undefined;
    public enableContactButton: boolean = false;
    public displayHiphen: boolean = true;
    public socialMedias: Array<string> = [];
    public line1: string;
    public line2: string;
    public line3: string;
    public line4: string;


    constructor(
        public dialog: MatDialog,
        private readonly myConfigReader: ConfigReaderService,
        private readonly router: Router
    ) { }

    public ngOnInit(): void {
        forkJoin([
            this.myConfigReader.getAllExternalLinks(),
            this.myConfigReader.getContactDetails()
        ]).subscribe(async ([externalLinks, contactDetails]) => {
            this.externalLinks = externalLinks;
            this.socialMedias = Object.keys(this.externalLinks?.socialMidias) || [];
            this.contactDetails = new IContactDetails(contactDetails);
            this.enableContactButton = this.contactDetails.enableContactButton();
        });
        this.line1 = environment.line1;
        this.line2 = environment.line2;
        this.line3 = environment.line3;
        this.line4 = environment.line4;
    }

    public ngAfterViewInit(): void {
        this.checkDisplayHiphen();
    }

    @HostListener('window:resize', ['$event'])
    private checkDisplayHiphen() {
        const firstRightsLineHeight: number = document.getElementById('firstRightsLine').offsetHeight;
        this.displayHiphen = firstRightsLineHeight === 55;
    }

    public goToUrl(url: string): void {
        UtilService.goToUrl(url, this.externalLinks, this.router);
    }

    public checkConfiguration(url: string): boolean {
        return UtilService.checkConfiguration(url, this.externalLinks);
    }

    public openContactChannel(): void {
        const channel: EContactChannels = this.contactDetails.channelToUse();
        if (EContactChannels.EMAIL === channel){
            this.dialog.open( SimpleContactModalComponent, {
                panelClass: 'customDialog',
                data: {
                    contactDetails: this.contactDetails
                }
            } );
        }else if (EContactChannels.CHAT === channel){
            window.open(this.contactDetails.tawkTo);
        }
    }
}
